import { TimeZoneCode } from '../types';

const TIME_ZONE_IANA_NAME_MAP = {
  [TimeZoneCode.ChamorroStandardTime]: 'Pacific/Guam',
  [TimeZoneCode.SamoaStandardTime]: 'Pacific/Midway',
  [TimeZoneCode.HawaiiAleutianStandardTime]: 'Pacific/Honolulu',
  [TimeZoneCode.HawaiiAleutianTime]: 'America/Adak',
  [TimeZoneCode.AlaskaTime]: 'America/Anchorage',
  [TimeZoneCode.PacificTime]: 'America/Los_Angeles',
  [TimeZoneCode.MountainStandardTime]: 'America/Phoenix',
  [TimeZoneCode.MountainTime]: 'America/Denver',
  [TimeZoneCode.CentralStandardTime]: 'America/Regina',
  [TimeZoneCode.CentralTime]: 'America/Chicago',
  [TimeZoneCode.EasternStandardTime]: 'America/Atikokan',
  [TimeZoneCode.EasternTime]: 'America/New_York',
  [TimeZoneCode.AtlanticStandardTime]: 'America/Puerto_Rico',
  [TimeZoneCode.AtlanticTime]: 'America/Halifax',
  [TimeZoneCode.NewfoundlandTime]: 'America/St_Johns',
  [TimeZoneCode.BritishColumbiaTime]: 'America/Vancouver',
  [TimeZoneCode.AlbertaTime]: 'America/Edmonton',
  [TimeZoneCode.ManitobaTime]: 'America/Winnipeg',
};

// These zones stopped observing DST on 2026-11-01, but browsers with older time zone data still fall back.
// From that date, use long-established zones with the same fixed offset. Earlier dates keep the provincial
// zone so past winter times stay correct. Both zones have the same offset at the switch-over.
const PERMANENT_TIME_START = new Date('2026-11-01T00:00:00Z');
const FIXED_OFFSET_TIME_ZONE_MAP: Record<string, string> = {
  'America/Vancouver': 'America/Whitehorse', // UTC-7
  'America/Edmonton': 'America/Regina', // UTC-6
  'America/Winnipeg': 'America/Atikokan', // UTC-5
};

export const getTimeZoneIANAName = (timeZone: TimeZoneCode): string => TIME_ZONE_IANA_NAME_MAP[timeZone];

export const getTimeZoneForDate = (timeZone: string, date: Date): string =>
  date >= PERMANENT_TIME_START ? FIXED_OFFSET_TIME_ZONE_MAP[timeZone] ?? timeZone : timeZone;
